export class Constants {
  static readonly LOCAL_STORAGE = 'LOCAL_STORAGE';
  static readonly SESSSION_STORAGE = 'SESSSION_STORAGE';
  static readonly AUTH_TOKEN = 'AUTH_TOKEN';
  static readonly USER_ROLE = 'USER_ROLE';
  static readonly USER_NAME = 'USER_NAME';
  static readonly TM_ID = 'TM_ID';
  static readonly MOBILE_NO = 'MOBILE_NO';
  static readonly SERVICE_PROVIDER = 'SERVICE_PROVIDER';
  static readonly SP = 'SP';
  static readonly COMPLAINT_NUMBER = 'COMPLAINT_NUMBER';
  static readonly COMPLAINT_EMAIL = 'COMPLAINT_EMAIL';
  static readonly COMPLAINT_MOBILE = 'COMPLAINT_MOBILE';
  static readonly COMPLAINT_AREACODE = 'COMPLAINT_AREACODE';
  static readonly COMPLAINT_DELNUMBER = 'COMPLAINT_DELNUMBER';
  static readonly VIRTUAL_MOB_ID = 'VIRTUAL_MOB_ID';
  static readonly LOGIN_FLAG = 'LOGIN_FLAG';
  static readonly ENTITY_REF_NO = 'ENTITY_REF_NO';
  static readonly T_OAP_OPERATOR = 'T_OAP_OPERATOR';
  static readonly DAYS = 'DAYS';
  static readonly TIMEBAND = 'TIMEBAND';
  static readonly MODEOFCOMMUNICATION = 'MODEOFCOMMUNICATION';
  static readonly PROMOTIONMESSAGE = 'PROMOTIONMESSAGE';

  static readonly ENTITY_REF_NO_LOGIN = 'ENTITY_REF_NO_LOGIN';
  static readonly HEADER_ID = 'HEADER_ID';
  static readonly RTM_NAME = 'rtmName';
  static readonly ENTITY_NAME = 'ENTITYNAME';
  static readonly HOME_ROLE = 'HOME_ROLE';
  static readonly ORG_NAME = 'ORG_NAME';
  static readonly NCPRFILENAME = 'NCPRFILENAME';
  static readonly NCPRREQUESTID = 'NCPRREQUESTID';
  static readonly NCPRREQUESTDATE = 'NCPRREQUESTDATE';
  static readonly ENTITY_ROLE = 'ENTITY_ROLE';
  static readonly ENTITY_TYPE = 'ENTITY_TYPE';
  static readonly ENTITY_ADDR = 'ENTITY_ADDR';
  static readonly ORG_TYPE = 'ORG_TYPE';
  static readonly CHILD_ORG_FLAG = 'CHILD_ORG_FLAG';
  static readonly CHILD_ORG_NAME = 'CHILD_ORG_NAME';
  static readonly Hash_KYC_Doc = 'Hash_KYC_Doc';
  static readonly ENTITY_CLASS = 'Entity_Class';
  static readonly POI = 'POI';
  static readonly ENTITY_ID = 'Entity_ID';

  static readonly ENTITY_CONTACTNAME = 'Entity_ContactName';
  static readonly ENTITY_MOBILE_NO = 'Entity_Mobile_No';
  static readonly Entity_EmailID = 'Entity_EmailID';

  static readonly NAME = "NAME";
  static readonly URN = 'URN';

  static readonly USERID_OTP = 'USERID_OTP';

  static readonly HEADER_MOBILE = 'HEADER_MOBILE';
  static readonly HEADER_EMAIL = 'HEADER_EMAIL';
  static readonly INDUSTRYSECTOR = 'INDUSTRYSECTOR';

  static readonly TTSL_ID = 'TTSL_ID';
  static readonly Ttsl_ProcessRole = 'Ttsl_ProcessRole';
  static readonly TATAEMPROLES = 'TATAEMPROLES';
  static readonly ProcessRole = 'ProcessRole';
  static readonly TATAUSER_NAME = 'TATAUSER_NAME';
  static readonly TTSL_REF_NO = 'TTSL_REF_NO';
  static readonly PAYMENTFORURN = 'PAYMENTFORURN';
  static readonly TRANSACTIONAMOUNT = 'TRANSACTIONAMOUNT';
  static readonly URNFORGST = 'URNFORGST';
  static readonly GSTACTIONSOURCE = 'GSTACTIONSOURCE';
  static readonly CONSENTTEMPLATEID = 'CONSENTTEMPLATEID';
  static readonly CSTLINKDELINK = 'CSTLINKDELINK';

  static readonly CALLBACKURL = 'CALLBACKURL';
  static readonly ACCESS_TKN =  'ACCESS_TKN';
  static readonly REFRESH_TKN = 'REFRESH_TKN';
   static readonly MODULEFORPAYMENT = 'MODULEFORPAYMENT';

  static readonly PAYMENT_FLAG = "PAYMENT_FLAG"; //Added for Entity-Payment
  static readonly URNORENTID = "URNORENTID";
  static readonly LAST_LOGIN = "LAST_LOGIN";
  static readonly ERR_MSG = "ERR_MSG";

  //For voiceModule
  static readonly MAXCNTBYPETOTM = "2" ;
  static readonly MAXCNTBYREGTOTM = "2";
  static readonly MAXCNTBYREGTOPE = "2";
  static readonly TMCOOLINGPERIOD = "3";
  static readonly PECOOLINGPERIOD = "3";
  static readonly REGCOOLINGPERIOD = "3";
  
  //for voice service header
  static readonly MAXCNTBYTMTOPE = "2";

  static readonly PWDEXPBALANCEDAYS="PWDEXPBALANCEDAYS"
  
    //for Key based authentication
    static readonly ENTITY_TOKEN = 'ENTITY_TOKEN'; //pradnya key based authentication

    //FOR ENTITY RENEWAL
    static readonly ENTITY_EXPIRY = 'ENTITY_EXPIRY';
    static readonly ENTITYSTATUS = 'ENTITYSTATUS';
}
